import React, { useState } from "react";
import Api from "../../../api/global.service";
import ApiUrl from "../../../constants/Api";
import DataTable from "react-data-table-component";
import DeleteButton from "../../../nuup/componentes/Generales/DeleteButton";
import estiloGeneral from "../../../nuup/componentes/Tablas/estiloGeneral";
import "../../../nuup/styles/Tablas.css";
import BlockUi from "react-block-ui";
import { useFetchWithPaginate } from "../../../nuup/hooks/useFetchWithPaginate";
import { Link } from "react-router-dom";
import HerramientasTablas from "../../../nuup/componentes/Tablas/HerramientasTablas/HerramientasTablas";
import { useEffect } from "react";

const ProductoresTabla = (props) => {
  const [verDetalles, setVerDetalles] = useState(false);
  const [idAviso, setIdAviso] = useState(false);
  const [datosFiltrados, setDatosFiltrados] = useState([]);

  const columns = [
    {
      name: "PRODUCTOR",
      selector: "nombre_productor",
      sortable: true,
    },
    {
      name: "OPCIONES",
      button: true,
      cell: (row) => {
        if (row.existe === 0) {
          return (
            <button
              className="btn btn-warning"
              onClick={() => props.onAgrega(row.id_productor)}
            >
              <i className="fa fa-plus"></i>
            </button>
          );
        }
        if (row.existe === 1) {
          return (
            <button
              className="btn btn-danger"
              onClick={() => props.onQuita(row.id_productor)}
            >
              <i className="fa fa-trash"></i>
            </button>
          );
        }
      },
    },
  ];

  const quitaProductor = () => {};

  useEffect(() => {
    setDatosFiltrados(props.data);
  }, [props.data]);

  return (
    <>
      <BlockUi
        tag="div"
        message=""
        blocking={datosFiltrados.length === 0}
        renderChildren={true}
      >
        <DataTable
          pagination
          columns={columns}
          data={datosFiltrados}
          noDataComponent={"Sin datos por mostrar"}
        />
      </BlockUi>
    </>
  );
};
export default ProductoresTabla;
